import { ChatResult } from "@memberjunction/ai";
import { RegisterClass } from "@memberjunction/global";
import { BaseMessageConverter } from "./BaseMessageConverter.js";


@RegisterClass(BaseMessageConverter, 'OpenAILLMConverter')
export class OpenAILLMConverter extends BaseMessageConverter {

    public TransformGeneratedResponse(message: ChatResult): ChatResult {
        return message;
    }

    public TransformQualityCheckResponse(message: ChatResult): ChatResult {
        return message;
    }
}

export function LoadOpenAILLMMessageConverter(): void {

}